/**
 * Shared plan modules config for Landing Page (Transparent Pricing) and module plan.
 * Single source of truth so plan features stay in sync everywhere.
 * Keys are i18n keys under "landing" (e.g. t('landing.plan_feature_gps_time_tracking')).
 */
export const PLAN_MODULE_KEYS = {
  starter: [
    'plan_feature_gps_time_tracking',
    'plan_feature_full_history',
    'plan_feature_hr_documents',
    'plan_feature_photo_audit',
    'plan_feature_profile_team',
    'plan_feature_reports',
    'plan_feature_billing',
    'plan_feature_maps',
    'plan_feature_gps',
    'plan_feature_employee_management',
    'plan_feature_help_faq',
    'plan_feature_dashboard',
    'plan_feature_support_included'
  ],
  business: [
    'plan_feature_all_starter',
    'plan_feature_leave_management',
    'plan_feature_leave_balance',
    'plan_feature_calendar',
    'plan_feature_scheduling',
    'plan_feature_training',
    'plan_feature_dashboard',
    'plan_feature_announcements',
    'plan_feature_suggestion_box',
    'plan_feature_support_included'
  ],
  enterprise: [
    'plan_feature_all_business',
    'plan_feature_expense_report',
    'plan_feature_live_chat',
    'plan_feature_badge_qr',
    'plan_feature_performance'
  ]
};

/** Default pricing/metadata for landing page. Fixed monthly EUR per plan (no per-employee). */
export const PLAN_META = {
  starter: {
    name: 'Starter',
    price: '2.90',
    pricePerEmployee: '',
    maxEmployees: 10,
    popular: false
  },
  business: {
    name: 'Business',
    price: '4.90',
    pricePerEmployee: '',
    maxEmployees: 50,
    popular: true
  },
  enterprise: {
    name: 'Enterprise',
    price: '6.90',
    pricePerEmployee: '',
    maxEmployees: null,
    popular: false
  }
};
